import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  TextField, 
  Button, 
  Grid,
  Alert,
  FormLabel
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { contactFormStyles } from '../styles';

export const ContactForm = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí iría la lógica de envío del formulario
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    
    // Reset form después de 3 segundos
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        subject: '',
        message: ''
      });
    }, 3000);
  };

  return (
    <Box sx={contactFormStyles.container}>
      <Typography variant="h2" sx={contactFormStyles.title}>
        {t('ecommerce.support.contactForm.title', 'Contáctanos')}
      </Typography>
      
      <Typography sx={contactFormStyles.description}>
        {t('ecommerce.support.contactForm.description', 'Completa el formulario y nuestro equipo se pondrá en contacto contigo a la brevedad.')}
      </Typography>

      {isSubmitted && (
        <Alert severity="success" sx={{ mb: 3 }}>
          {t('ecommerce.support.contactForm.successMessage', '¡Mensaje enviado exitosamente! Te contactaremos pronto.')}
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box sx={contactFormStyles.fieldContainer}>
              <FormLabel sx={contactFormStyles.fieldLabel}>
                {t('ecommerce.support.contactForm.name', 'Nombre completo')} *
              </FormLabel>
              <TextField
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder={t('ecommerce.support.contactForm.namePlaceholder', 'Ingresa tu nombre completo')}
                required
                fullWidth
                sx={contactFormStyles.textField}
              />
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <Box sx={contactFormStyles.fieldContainer}>
              <FormLabel sx={contactFormStyles.fieldLabel}>
                {t('ecommerce.support.contactForm.email', 'Correo electrónico')} *
              </FormLabel>
              <TextField
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder={t('ecommerce.support.contactForm.emailPlaceholder', 'tu.email@ejemplo.com')}
                required
                fullWidth
                sx={contactFormStyles.textField}
              />
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <Box sx={contactFormStyles.fieldContainer}>
              <FormLabel sx={contactFormStyles.fieldLabel}>
                {t('ecommerce.support.contactForm.phone', 'Teléfono')}
              </FormLabel>
              <TextField
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder={t('ecommerce.support.contactForm.phonePlaceholder', '(555) 123-4567')}
                fullWidth
                sx={contactFormStyles.textField}
              />
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <Box sx={contactFormStyles.fieldContainer}>
              <FormLabel sx={contactFormStyles.fieldLabel}>
                {t('ecommerce.support.contactForm.company', 'Empresa')}
              </FormLabel>
              <TextField
                name="company"
                value={formData.company}
                onChange={handleInputChange}
                placeholder={t('ecommerce.support.contactForm.companyPlaceholder', 'Nombre de tu empresa')}
                fullWidth
                sx={contactFormStyles.textField}
              />
            </Box>
          </Grid>
          
          <Grid item xs={12}>
            <Box sx={contactFormStyles.fieldContainer}>
              <FormLabel sx={contactFormStyles.fieldLabel}>
                {t('ecommerce.support.contactForm.subject', 'Asunto')} *
              </FormLabel>
              <TextField
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
                placeholder={t('ecommerce.support.contactForm.subjectPlaceholder', 'Describe brevemente tu consulta')}
                required
                fullWidth
                sx={contactFormStyles.textField}
              />
            </Box>
          </Grid>
          
          <Grid item xs={12}>
            <Box sx={contactFormStyles.fieldContainer}>
              <FormLabel sx={contactFormStyles.fieldLabel}>
                {t('ecommerce.support.contactForm.message', 'Mensaje')} *
              </FormLabel>
              <TextField
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder={t('ecommerce.support.contactForm.messagePlaceholder', 'Describe tu consulta en detalle...')}
                required
                multiline
                rows={4}
                fullWidth
                sx={contactFormStyles.textField}
              />
            </Box>
          </Grid>
          
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              sx={contactFormStyles.submitButton}
              disabled={isSubmitted}
            >
              {isSubmitted 
                ? t('ecommerce.support.contactForm.sending', 'Enviando...') 
                : t('ecommerce.support.contactForm.submit', 'Enviar mensaje')
              }
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ContactForm; 